import { type FC, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'

import { getAriaLabel } from 'shared/lib'
import styles from './styles.module.scss'

type IRouterLinkProps = {
  children: ReactNode
  route: string
  callBack?: () => void
}

export const RouterLink: FC<IRouterLinkProps> = observer(
  ({ route, children = 'vue', callBack }) => {
    return (
      <div
        className={styles.link}
        onClick={() => {
          callBack?.()
          uiStore.changeRouteViaVue({
            path: route,
          })
        }}
        aria-label={getAriaLabel('RouterLink')}
      >
        {children}
      </div>
    )
  }
)
